// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	BasketballIcon,
	BombIcon,
	CpuIcon,
	CrosshairIcon,
	FilmSlateIcon,
	GameControllerIcon,
	type Icon,
	MusicNotesIcon,
	PawPrintIcon,
	SmileyWinkIcon,
	SoccerBallIcon,
	SpiralIcon,
	SwordIcon,
} from '@phosphor-icons/react';

// Micup akis-kategori: the admins file each category under one emoji; the known ones are drawn as an app icon (no game
// logos), any other emoji stays as it is.
const ICONS: ReadonlyMap<string, Icon> = new Map([
	['⚽', SoccerBallIcon],
	['🏀', BasketballIcon],
	['🎯', CrosshairIcon],
	['💣', BombIcon],
	['🧙', SwordIcon],
	['🎮', GameControllerIcon],
	['🎵', MusicNotesIcon],
	['🎬', FilmSlateIcon],
	['🍥', SpiralIcon],
	['💻', CpuIcon],
	['😂', SmileyWinkIcon],
	['🐾', PawPrintIcon],
]);

const PRESENTATION_SELECTOR = String.fromCharCode(0xfe0f);

export function feedCategoryIcon(emoji: string): Icon | null {
	return ICONS.get(emoji.replaceAll(PRESENTATION_SELECTOR, '').trim()) ?? null;
}
